export default "__VITE_ASSET__BPiWq7mf__"